var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-module"},[_c('div',{staticClass:"download-icon"},[_vm._t("download-icon")],2),_vm._v(" "),_c('a',{staticClass:"download-btn",attrs:{"href":_vm.href,"target":"_blank"}},[_vm._t("download-btn")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32db0db0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/miner/plugins/DownloadModule.vue
// module id = null
// module chunks = 